module.exports = __webpack_public_path__ + "static/guides-44d24e4d36e3e385b7cd2f38e955c5e7.png";